import React from "react";
import Backdrop from '@mui/material/Backdrop';

const PageLocading = () => {
    return(
        <Backdrop
            sx={{ color: '#fff' }}
            open={true}
        >
            <img 
                src={`/assets/img/instafix-logo-1.png`} 
                className="navbar-brand-img" 
                alt="main_logo"
                style={{
                    width: '20%',
                    height: '10%'
                }}  
            />
        </Backdrop>
    );
}
  
export default PageLocading;